import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import {Plus} from 'lucide-react';
const RealtimeMiniBarChart = ({userCountryOverview = []}) => {
    const [data, setData] = useState(Array.from({ length: 30 }, () => Math.random() * 100));

    useEffect(() => {
        const interval = setInterval(() => {
            setData((prev) => [...prev.slice(1), Math.random() * 100]);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const option = {
        grid: { left: 0, right: 0, top: 0, bottom: 0 },
        xAxis: { type: "category", show: false, data: data.map((_, i) => i) },
        yAxis: { type: "value", show: false },
        series: [
            {
                type: "bar",
                data,
                itemStyle: { color: "#2f5aa2", borderRadius: [2, 2, 0, 0] },
                barWidth: "50%"
            }
        ],
        animation: false
    };

    return (
        <div className="card" style={{ height: "450px" }}>
            <div className="card-body">
                <div>
                    <h5>Visitors</h5>
                    <p className="fs-9 fw-semibold">Users across countries</p>
                </div>
                <div className="text-center mb-3">
                    <h5 className='mb-2'>197 <span className="fs-8">User per second</span></h5>
                    <ReactECharts option={option} className='w-100' style={{height: 70}}/>
                </div>
                <div className="scrollbar ms-n1 ps-1 pe-1" style={{ height: "240px" }}>
                    <table className="phoenix-table fs-10 mb-0 mt-3 table table-sm">
                        <thead className="fs-0">
                        <tr>
                            <th className="fs-10 sort">COUNTRY NAME</th>
                            <th className="fs-10 sort">USERS</th>
                            <th className="text-end fs-10 sort">PERCENT</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            userCountryOverview.map((item, index) => (
                                <tr key={index}>
                                    <td className="py-2">
                                        <div className="d-flex align-items-center text-primary py-md-1 py-xxl-0"
                                             data-discover="true">
                                            <img alt="" width="24" src={`https://flagsapi.com/${item.CountryCode}/flat/32.png`}/>
                                            <p className="mb-0 ps-3 fw-bold fs-9">{item.Country}</p>
                                        </div>
                                    </td>
                                    <td className="py-2 align-middle">
                                        <h6>{item.UsersCount}</h6>
                                    </td>
                                    <td className="align-middle text-end fw-semibold py-2">
                                <span className="fs-10 badge-bt badge-bt-danger badge">
                                    <Plus size={9}/>
                                    <span className="badge-label">{item.PercentUsers}%</span>
                                </span>
                                    </td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RealtimeMiniBarChart;
